import { createFileRoute } from '@tanstack/react-router';

import { HelpButton } from '../components/help/HelpButton';
import { PageHead } from '../components/layout';
import { useAdminAudit } from '../lib/queries';

export const Route = createFileRoute('/settings/audit')({ component: AuditPageInner });

export function AuditPageInner() {
  const { data, isPending, error } = useAdminAudit();

  return (
    <div className="page">
      <PageHead
        crumbs={['ระบบ', 'บันทึกการตรวจสอบ']}
        title="บันทึกการตรวจสอบ (Audit Log)"
        actions={<HelpButton guide="settings-audit" />}
      />
      <div className="tbl-shell">
        <table className="tbl">
          <thead>
            <tr>
              <th>เวลา</th>
              <th>ผู้กระทำ</th>
              <th>การกระทำ</th>
              <th>ประเภท</th>
              <th>เป้าหมาย</th>
            </tr>
          </thead>
          <tbody>
            {isPending ? (
              <tr>
                <td colSpan={5} className="muted" style={{ padding: 24, textAlign: 'center' }}>
                  กำลังโหลด…
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td
                  colSpan={5}
                  style={{ padding: 24, textAlign: 'center', color: 'var(--negative)' }}
                >
                  โหลดล้มเหลว: {error.message}
                </td>
              </tr>
            ) : (
              (data?.rows ?? []).map((row) => (
                <tr key={row.id}>
                  <td className="muted" style={{ whiteSpace: 'nowrap' }}>
                    {new Date(row.createdAt).toLocaleString('th-TH')}
                  </td>
                  <td>{row.actorLabel}</td>
                  <td className="code">{row.action}</td>
                  <td className="muted">{row.targetType}</td>
                  <td className="muted">{row.targetLabel ?? row.targetId ?? '—'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
